import { createComponentElement } from "@modules/content/creators/createComponentElement";
import { useComponentData } from "@modules/content/hooks/useComponentData";
import { ContentComponent } from "@modules/content/types";
import { useGetContentProgress } from "@modules/content/hooks/useGetContentProgress";
import { defaultPageSize } from "@modules/content/helpers/content";
import {
  RepeatedPrayerList,
  RepeatedPrayerListItemParameters,
  RepeatedPrayerListParameters,
} from "@components/layouts/content/RepeatedPrayerList";

import { useLockedContents } from "../hooks/useLockedContent";
import { ExtraProps } from ".";

const Component = createComponentElement<{
  extraProps?: ExtraProps;
}>((props, ref) => {
  const {
    getParameterValues,
    getItemsParameterValues,
    contents,
    content,
    isLoading,
    isLoadingMore,
    componentData,
    uniqueId,
    getMore,
    refresh,
    meta: { hasNextPage },
  } = useComponentData<
    RepeatedPrayerListParameters,
    RepeatedPrayerListItemParameters
  >(
    {
      ...props,
      pageNumber: 1,
      pageSize: 50,
    },
    ref
  );

  const { title } = getParameterValues(["title"]);

  const { isLockedContent } = useLockedContents(contents || []);
  const lockedContents = isLockedContent.result;

  return (
    <RepeatedPrayerList
      contents={contents?.map((c) => {
        const found = lockedContents?.find((l) => l.id === c.id);

        return {
          ...c,
          isLocked: found?.isLocked,
          lockType: found?.lockType,
        };
      })}
      isLoading={isLoading}
      items={getItemsParameterValues([
        "repetition",
        "source",
        "text",
        "title",
      ]).map((item) => {
        return {
          id: item.content.id,
          title: item.content.title,
          repetition: item.values.repetition,
          source: item.values.source,
          text: item.values.text,
        };
      })}
      parameterValues={{
        title: title || props.context?.title || "",
      }}
      //   extraProps={props.extraProps}
    />
  );
});

export const RepeatedPrayerListComponent: ContentComponent = {
  identifier: "COM:REPEATED:PRAYER",
  component: Component,
};
